export default __webpack_public_path__ + "static/media/problem-solving.a1738301.svg";